import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FindWorkSection } from './components/FindWorkSection';
import { ExploreOpportunities } from './components/ExploreOpportunities';
import { EmployerSolutions } from './components/EmployerSolutions';
import { WorkforcePartner } from './components/WorkforcePartner';
import { NextStep } from './components/NextStep';
import { GulfCoastExpertise } from './components/GulfCoastExpertise';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <FindWorkSection data-id="element-4" />
        <ExploreOpportunities data-id="element-5" />
        <EmployerSolutions data-id="element-6" />
        <WorkforcePartner data-id="element-7" />
        <NextStep data-id="element-8" />
        <GulfCoastExpertise data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}